import { render, staticRenderFns } from "./FBanner.vue?vue&type=template&id=d0b4a89e&"
import script from "./FBanner.vue?vue&type=script&lang=js&"
export * from "./FBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports